import { Content } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { generateImage } from "@/faker/generateImage";
import { generateDescription } from "@/faker/generateDescription";
import { createTitle } from "@/functions/createTitle";
import JobsFeed from "@/components/JobsFeed";
import SeoHead from "@/components/SeoHead";


export default function JobsPage({ content }) {
  return (
    <>
      {/* <Content items={content} /> */}
      <div style={{marginTop: '120px'}}>
        <SeoHead
            page_name={`All jobs everywhere · EarthStream`}
            canonical_link={`https://www.earthstreamglobal.com/jobs`}
          />
        <JobsFeed />
      </div>
      
    </>
  );
}